export default __webpack_public_path__ + "static/media/logo.21930d77.svg";